const PUNCT_AFTER_NEWLINE = new Set(['，', '。', '︰', '；', '！', '？', '：']);

/** Insert newline after listed punctuation when not already followed by newline. */
export function formatChinesePunctuation(text) {
  if (text == null || text === '') return '';
  let out = '';
  const endPos = new Array(text.length + 1);
  endPos[0] = 0;
  for (let i = 0; i < text.length; i += 1) {
    const c = text[i];
    out += c;
    if (PUNCT_AFTER_NEWLINE.has(c) && (i + 1 >= text.length || text[i + 1] !== '\n')) {
      out += '\n';
    }
    endPos[i + 1] = out.length;
  }
  return { formatted: out, endPos };
}
